import { render, staticRenderFns } from "./PersonalDataPolicy.vue?vue&type=template&id=0e75024b&"
import script from "./PersonalDataPolicy.vue?vue&type=script&lang=js&"
export * from "./PersonalDataPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports